import styled from 'styled-components'

export const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
